import { createMuiTheme } from "@material-ui/core/styles";

// Single source of truth for brand color and typography. Keep MUI v4
// compatibility (createMuiTheme) since the rest of the app is on v4.
const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#2C7AA0",
            light: "#5FA1C5",
            dark: "#205A78",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#1F2937",
            light: "#374151",
            dark: "#111827",
            contrastText: "#FFFFFF",
        },
        error: {
            main: "#DC2626",
        },
        success: {
            main: "#16A34A",
        },
        background: {
            default: "#F8FAFC",
            paper: "#FFFFFF",
        },
        text: {
            primary: "#111827",
            secondary: "#4B5563",
        },
    },
    typography: {
        fontFamily:
            '"Inter", "Roboto", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },
        button: { textTransform: "none", fontWeight: 600 },
    },
    shape: {
        borderRadius: 8,
    },
    overrides: {
        MuiPaper: {
            rounded: { borderRadius: 10 },
            elevation1: {
                boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)",
            },
        },
        MuiTableCell: {
            head: {
                fontWeight: 600,
                color: "#1F2937",
                backgroundColor: "#F1F5F9",
            },
        },
    },
});

export default theme;
